<div class="container" [ngStyle]="{'background-color' : popinType === 'home'? '#D5EA7D': '#EE7203'}">
    <div class="label">{{titleBloc|translate}}</div>
    <!-- <div class="deliveryInformation" *ngIf="hasDeliveryInformation && popinType === 'home'">
      <div class="deliveryDate">{{deliveryDate | date:"EEEE d MMMM yyyy" :'': 'fr' }}</div>
      <div class="deliveryAddress">
        <div *ngIf="isHome">
          <div>{{deliveredHomeAddress.name}} {{deliveredHomeAddress.firstName}}</div>
          <div *ngIf="deliveredHomeAddress.companyName">{{deliveredHomeAddress.companyName}}</div>
          <div>{{deliveredHomeAddress.address.address0}} {{deliveredHomeAddress.address.address1}} {{deliveredHomeAddress.address.address2}} {{deliveredHomeAddress.address.address3}}</div>
          <div>{{deliveredHomeAddress.address.zipCode}} {{deliveredHomeAddress.address.city}}</div>
        </div>
        <div *ngIf="!isHome">
          <div>{{deliveredPickupAddress.siteName}}</div>
          <div>{{deliveredPickupAddress.address0}} {{deliveredPickupAddress.address1}} {{deliveredPickupAddress.address2}}</div>
          <div>{{deliveredPickupAddress.zipCode}} {{deliveredPickupAddress.city}}</div>
        </div>
      </div>
    </div> -->
    <div class="button" (click)="callPopin(popinType)">
        <div class="button_action">{{button | translate}}</div>
    </div>
</div>
